import type {
  EmbeddingModel,
  KnowledgeBase,
  KnowledgeBaseListResult,
} from "../../domain/entities/knowledge-base";
import type { UesConfig } from "../../domain/entities/ues-config";
import type {
  KnowledgeBaseListModel,
  KnowledgeBaseModel,
  MetadataModel,
  UesConfigModel,
} from "../models/knowledge-base-model";

const toKnowledgeBase = (model: KnowledgeBaseModel): KnowledgeBase => ({
  id: model._id,
  userId: model.user_id,
  name: model.name,
  chunkingConfig: {
    chunkSize: model.chunking_config.chunk_size,
    chunkOverlap: model.chunking_config.chunk_overlap,
    embeddingModelCode: model.chunking_config.embedding_model,
  },
});

export const toKnowledgeBaseList = (
  model: KnowledgeBaseListModel,
): KnowledgeBaseListResult => ({
  items: model.items.map(toKnowledgeBase),
  total: model.total,
});

export { toKnowledgeBase };

export const toUesConfig = (model: UesConfigModel): UesConfig => ({
  enabled: model.enabled,
  docTypeIds: model.doc_type_ids,
});

export const toUesConfigBody = (config: UesConfig): UesConfigModel => ({
  enabled: config.enabled,
  doc_type_ids: config.docTypeIds,
});

export const toEmbeddingModels = (model: MetadataModel): EmbeddingModel[] =>
  model.embedding ?? model.embeddingModels ?? [];
